var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"root",staticClass:"menu",style:({
    width: _vm.matchContentWidth ? 'auto' : _vm.width + 'px'
  })},[_c('ul',{staticClass:"menu__content"},_vm._l((_vm.items),function(item){return _c('li',{key:item.id,on:{"click":function($event){return _setup.itemSelected(item.id)}}},[(item.content)?_c('span',[_vm._v(_vm._s(item.content))]):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }